var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgZip = function SvgZip(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 20.199",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#74b5e6",
    d: "M0 11.999h14v8.2H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#63849f",
    d: "M11.821 5.875a.22.22 0 0 0-.2-.136H9.198V.221A.22.22 0 0 0 8.973 0H5.446a.22.22 0 0 0-.221.221v5.517H2.798a.221.221 0 0 0-.156.377l4.4 4.418a.22.22 0 0 0 .313 0l4.418-4.418a.22.22 0 0 0 .048-.24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.029 18.451a.438.438 0 0 1-.367-.734l2.515-3.341H2.092a.434.434 0 1 1 0-.867h2.847c.536 0 .692.507.311.918l-2.409 3.128h2.3a.45.45 0 1 1-.056.9H2.033ZM6.413 13.987a.467.467 0 0 1 .933 0v4.033a.467.467 0 0 1-.933 0ZM8.598 13.987a.486.486 0 0 1 .48-.488h1.632a1.766 1.766 0 0 1 0 3.532H9.531v.933a.443.443 0 0 1-.452.487.477.477 0 0 1-.48-.487v-3.977Zm.932.4v1.76h1.179a.88.88 0 0 0 0-1.76Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZip);
export default ForwardRef;